<template>
    <ul class="ivu-dropdown-menu"><slot></slot></ul>
</template>
<script>
    export default {
        name: 'DropdownMenu'
    };
</script>



// WEBPACK FOOTER //
// src/components/dropdown/dropdown-menu.vue